import { delay } from 'redux-saga';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { sectionApi } from '../services';

import {
  LOADING_DATA_START,
  LOADING_DATA_FINISHED,
} from '../reducers/loading.reducer';

import {
  BOOKLET_SECTION_EDIT,
  BOOKLET_SECTION_EDIT_LAYOUT,
  BOOKLET_SECTION_SAVE,
  BOOKLET_SECTION_SAVE_SUCCESS,
  BOOKLET_SECTION_DELETE,
  BOOKLET_SECTION_DELETE_SUCCESS,
} from '../reducers/booklet.reducer';
import { handleError } from './helper';
import * as bookletSelectors from '../selectors/booklet.selectors';
import { showNotification } from '../helpers/notification';

function* editSectionRequest({
  payload: { id, index, section = { title: '', name: '', description: '' } },
}) {
  try {
    yield put({ type: LOADING_DATA_START });

    yield call(delay, 1000);
    const { data } = yield handleEditSectionRequest(id, index, section);
    yield put({
      type: BOOKLET_SECTION_SAVE_SUCCESS,
      payload: { index, section: data },
    });
  } catch (error) {
    const message = yield* handleError(error, 'Booklet save failed.');
    showNotification(message);
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* saveSectionRequest({ payload: { id, index, title, size } }) {
  try {
    yield put({ type: LOADING_DATA_START });

    const getSectionsLength = state => state.booklet.sections.length;
    const sectionsLength = yield select(getSectionsLength);

    const section = {
      orderNumber: sectionsLength,
      isHiddenTitle: false,
      title,
      description: '',
      layouts: {},
      fragments: [],
      size,
    };

    const { data } = yield call(sectionApi.createSection, {
      id,
      section,
    });

    yield put({
      type: BOOKLET_SECTION_SAVE_SUCCESS,
      payload: { index, section: data },
    });
  } catch (error) {
    const message = yield* handleError(error, 'Section save failed.');
    showNotification(message);
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* editSectionLayoutRequest({
  payload: { index, section = { title: '', name: '', description: '' } },
}) {
  const bookletId = yield select(bookletSelectors.getBookletId);

  try {
    yield put({ type: LOADING_DATA_START });

    yield call(delay, 1000);
    const { data } = yield call(sectionApi.editSectionLayout, {
      id: bookletId,
      sectionId: section.id,
      layouts: section.layouts,
    });

    yield put({
      type: BOOKLET_SECTION_SAVE_SUCCESS,
      payload: { index, section: data },
    });
  } catch (error) {
    const message = yield* handleError(error, 'Section layout edit failed.');
    showNotification(message);
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* deleteSectionRequest({ payload: { index, bookletId, sectionId } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    yield call(sectionApi.deleteSection, { bookletId, sectionId });
    yield put({
      type: BOOKLET_SECTION_DELETE_SUCCESS,
      payload: { index },
    });
  } catch (error) {
    const message = yield* handleError(error, 'Delete section failed.');
    showNotification(message);
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function handleNewSectionFields(section, index) {
  if (!section.title) {
    section.title = `Section ${index + 1}`;
    section.isHiddenTitle = true;
    section.orderNumber = index;
  }
  return section;
}

export function* editSection() {
  yield takeLatest(BOOKLET_SECTION_EDIT, editSectionRequest);
}

export function* saveSection() {
  yield takeLatest(BOOKLET_SECTION_SAVE, saveSectionRequest);
}

export function* editSectionLayout() {
  yield takeLatest(BOOKLET_SECTION_EDIT_LAYOUT, editSectionLayoutRequest);
}

export function* deleteSection() {
  yield takeLatest(BOOKLET_SECTION_DELETE, deleteSectionRequest);
}

export function* handleEditSectionRequest(id, index, section) {
  return !section.id
    ? yield call(sectionApi.createSection, {
        id,
        section: handleNewSectionFields(section, index),
      })
    : yield call(sectionApi.editSection, { id, section });
}



// WEBPACK FOOTER //
// ./src/sagas/section.saga.js